import { DateTime } from 'luxon';
import { STEP_LABEL } from '../../../../../particles/api/extension';
import type { SupportTicketItem } from '../../../../../particles/api/extension';

const truncate = (s: string, max: number) =>
  s.length > max ? s.substring(0, max) + '…' : s;

const generateRows = (items: SupportTicketItem[]): TableRow[] =>
  items.map((item) => {
    const diag = item.diagnostics || {};
    return {
      id: item.id,
      submittedAt: item.submittedAt
        ? DateTime.fromISO(item.submittedAt).toLocaleString(
            DateTime.DATETIME_MED
          )
        : '-',
      from: item.userEmail || item.userId || '-',
      subject: item.subject || '-',
      description: item.description
        ? {
            type: 'text' as const,
            data: { text: truncate(item.description, 120) }
          }
        : '-',
      // What the user did before writing in, in order, with times.
      steps:
        item.steps && item.steps.length > 0
          ? {
              type: 'text' as const,
              data: {
                text: item.steps
                  .map((s) => {
                    const code = typeof s.data?.referenceCode === 'string' ? ` ${s.data.referenceCode}` : '';
                    return `${DateTime.fromISO(s.occurredAt).toFormat('HH:mm:ss')} ${STEP_LABEL[s.event] ?? s.event}${code}`;
                  })
                  .join(' → ')
              }
            }
          : '-',
      extensionVersion: diag.extensionVersion || '-',
      waWebVersion: diag.waWebVersion || '-'
    };
  });

export default generateRows;
